import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth';
import { app } from '@/main.js';

export const getDefaultState = () => ({
  organisation: {},
  organisations: {},
  isBambooEnabled: {},
  isPolicyOwner: false,
});

export const useUserStore = defineStore('user', {
  state: getDefaultState,
  getters: {
    getIsPolicyOwner(state) {
      return state.isPolicyOwner;
    },
  },
  actions: {
    resetState() {
      Object.assign(this, getDefaultState());
    },

    setOrganisation(data) {
      if (data && typeof data === 'object' && Object.keys(data).length > 0) {
        const resolvedId = data.organisation_id || data.id;
        if (resolvedId) {
          data = {
            ...data,
            id: data.id || resolvedId,
            organisation_id: data.organisation_id || resolvedId,
          };
        }
      }
      this.organisation = data;
      try {
        localStorage.setItem('organisation', JSON.stringify(data));
      } catch (e) {
        // Ignore localStorage errors
      }
    },

    setOrganisations(data) {
      this.organisations = data;
    },

    setBambooState(data) {
      this.isBambooEnabled = data;
    },

    setIsPolicyOwner(value) {
      this.isPolicyOwner = value;
    },

    async determinePolicyOwner() {
      const authStore = useAuthStore();

      // If the organisation doesn't have the policy product, no need to check further.
      if (!authStore.hasPolicy) {
        this.setIsPolicyOwner(false);
        return;
      }

      if (authStore.isSuperAdmin) {
        // No need to check for super admins, but let's ensure state is correct
        this.setIsPolicyOwner(true);
        return;
      }

      const orgID =
        authStore.isSuperAdmin || authStore.accessType === 'vertex_analyst'
          ? this.organisation?.id
          : this.organisation?.organisation_id;
      const userID = authStore.jwtPayload?.user_id;

      if (!orgID || !userID) {
        this.setIsPolicyOwner(false);
        return;
      }

      try {
        const axiosInstance = app?.config?.globalProperties?.$axios || axios;
        const response = await axiosInstance.get(
          `/trainings/organisations/${orgID}/users/${userID}/training-policy/is-owner`
        );
        if (response && response.data && response.data.success) {
          this.setIsPolicyOwner(response.data.is_policy_owner);
        } else {
          this.setIsPolicyOwner(false);
        }
      } catch (error) {
        console.error('Error determining policy ownership:', error);
        this.setIsPolicyOwner(false);
      }
    },
  },
  persist: true,
});

export default useUserStore;